import { render, staticRenderFns } from "./AuctionListView.vue?vue&type=template&id=3f5fffc8&scoped=true&"
import script from "./AuctionListView.vue?vue&type=script&lang=js&"
export * from "./AuctionListView.vue?vue&type=script&lang=js&"
import style0 from "./AuctionListView.vue?vue&type=style&index=0&id=3f5fffc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fffc8",
  null
  
)

export default component.exports